import { v4 as uuidv4 } from "uuid";
import { DraftSubmissionFormData } from "../../../../../components/modals/draftSubmissionModal/hooks/useDraftSubmissionFormDataWithErrorStates";
import { AuthStatusOptionModel } from "../../../../../data-model/authStatusOptions";
import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import { DraftSubmission } from "../../../../../data-model/draftSubmission";
import {
  JCodeDetails,
  MedicalPaOrder,
} from "../../../../../data-model/medicalPaOrdersModel";
import { PortalConfig } from "../../../../../data-model/portalConfigForDraftSubmission";
import { UpdateJCodeDataModel } from "../../../../../data-model/updateJCodeModel";
import { MedicalPaOrdersAuthStatus } from "../../../../../enums/medicalPaOrdersAuthStatus";
import { generateFullName } from "../../../../../utils/generateOrderDataForTable";
import { rotateLastSegmentFirst } from "../../../../../utils/getFullNameOfTheProvider";
import { getOrgIdForFetchExternalWorklist } from "../../../../../utils/organizationHelper";
import { transformTableDataToApiPayload } from "./transformRowDataForPayload";

export const generateDraftSubmissionPayloadOnSave = (
  formData: DraftSubmissionFormData,
  jCodes: JCodeDetails[],
  portalConfigData: PortalConfig[],
  singleMedicalPaOrder: MedicalPaOrder,
): DraftSubmission => {
  const j_codes = jCodes
    .filter((jCode) => formData.jCodes.includes(jCode.id ?? ""))
    .map((jCode) => ({
      j_code: jCode.j_code ?? "",
      description: jCode.description ?? "",
      id: jCode.id ?? "",
    }));

  const url =
    portalConfigData.find((portal) => portal.id === formData.portalName)
      ?.homepage_url ?? "";

  const portalName =
    portalConfigData.find((portal) => portal.id === formData.portalName)
      ?.portal_name ?? "";

  const id = uuidv4();

  const payload: DraftSubmission = {
    auth_id: formData.authId ?? "",
    payer_portal: portalName,
    j_codes: j_codes,
    url: url,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    plan_name: singleMedicalPaOrder.coverage?.primary?.plan_name ?? "",
    payer_name: singleMedicalPaOrder.coverage?.primary?.payer_name ?? "",
    member_id: singleMedicalPaOrder.coverage?.primary?.member_id ?? "",
    provider_name: rotateLastSegmentFirst(
      generateFullName(
        singleMedicalPaOrder.requesting_practitioner_details?.first_name ?? "",
        "",
        singleMedicalPaOrder.requesting_practitioner_details?.last_name ?? "",
      ),
    ),
    comments: formData.comments ?? "",
    file_path: formData.filePath ?? "",
    id: id,
  };

  return payload;
};

export const generateUpdateJCodePayloadOnSave = (
  formData: DraftSubmissionFormData,
  identifier: string,
  tableData: CptCodesTableRowModel[],
  authStatusOptions: AuthStatusOptionModel[],
): UpdateJCodeDataModel => {
  const payloadForExisitngOtherChanges: UpdateJCodeDataModel =
    transformTableDataToApiPayload(tableData, authStatusOptions, identifier);
  const j_codesForDraftSubmission =
    payloadForExisitngOtherChanges?.j_codes?.map((jCode) => ({
      ...jCode,
      auth_status: formData?.jCodes?.includes(jCode?.id || "")
        ? MedicalPaOrdersAuthStatus.AuthReview
        : jCode?.auth_status,
    }));
  return {
    identifier: identifier,
    j_codes: j_codesForDraftSubmission,
    org_id: getOrgIdForFetchExternalWorklist() || "",
  };
};
